import React from 'react';
import styles from './TableCard.module.css';

/**
 * TableCard — renders ranked data rows with sticky first column and horizontal scroll.
 *
 * Props:
 *   entry    {object} — registry entry with label, cardType, etc.
 *   cardData {object} — { rows: [...], columns: [{ key, label }] }
 *   metricId {string} — metric identifier
 */
const TableCard = ({ entry, cardData }) => {
  const rows = Array.isArray(cardData?.rows) ? cardData.rows : [];
  const columns = Array.isArray(cardData?.columns) ? cardData.columns : [];

  return (
    <div className={styles.card}>
      <div className={styles.label}>{entry.label}</div>
      {rows.length === 0 ? (
        <div className={styles.empty}>No data available</div>
      ) : (
        <div className={styles.wrapper}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>#</th>
                {columns.map((col) => (
                  <th key={col.key}>{col.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row, index) => (
                <tr key={index}>
                  <td className={styles.rank}>{index + 1}</td>
                  {columns.map((col) => {
                    const value = row[col.key];
                    const display =
                      typeof value === 'number' ? value.toLocaleString() : value;
                    return <td key={col.key}>{display}</td>;
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default TableCard;
